<template>
  <div>
    <layout-panel :collapse="true"
                  style="border:1px solid rgb(236,238,244)">
      <span slot="header">搜索</span>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               class="layout-search-form medium"
               @submit.native.prevent="onSearch()">
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="沟通人"
                          prop="communicator">
              <remote-select class="width-max"
                             v-model="search.adminuserid"
                             clearable
                             id-key="id"
                             keyword-key="name"
                             label-key="name"
                             value-key="id"
                             placeholder="请输入管理员名称搜索"
                             :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 5]}))"
                             :find-request="getPlatformUsersDetail">
              </remote-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="沟通日期"
                          prop="created_at">
              <el-date-picker v-model="search.created_at"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              align="center"
                              class="width-max"
                              :default-time="['00:00:00', '23:59:59']"
                              clearable>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <div class="margin b15">
        <el-button type="primary"
                   size="mini"
                   @click="addNewUserServiceRecord()">新增沟通记录
        </el-button>
      </div>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">

        <template v-for="(attr, index) of fields">
          <el-table-column :key="index"
                           v-bind="attr">
          </el-table-column>
        </template>

        <el-table-column fixed="right"
                         label="操作"
                         width="80">
          <template slot-scope="scope">
            <div class="button-gutter">
              <el-button type="primary"
                         size="mini"
                         @click="updateUserServiceRecord(scope.row)"
                         v-if="scope.row.adminuserid * 1 === user.id * 1">修改
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>

      <UserCommunicateForm :title="dialogTitle"
                           :record_obj="record_obj"
                           :lockUserId="lockUserId"
                           @closeAndRefresh="closeAndRefresh()"
                           :visible="dialogVisible">
      </UserCommunicateForm>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import dateTimePicker from '@core/mixins/dateTimePicker'
import UserCommunicateForm from '../../components/UserCommunicateForm'

export default {
  mixins: [table, dateTimePicker],
  components: {UserCommunicateForm},
  data () {
    return {
      searchRules: {},
      search: {
        record_id: null,
        adminuserid: null,
        userid: null,
        cellphone: null,
        created_at: null,
      },
      fields: [
        {prop: 'record_id', label: 'ID', width: 80},
        {prop: 'userid', label: '用户ID', width: 100},
        {prop: 'cellphone', label: '用户手机号', width: 110},
        {prop: 'communicate_type_cn', label: '沟通方式', width: 100},
        {prop: 'connect_status_cn', label: '沟通状态', width: 100},
        {prop: 'abnormal_reason_cn', label: '异常原因', width: 120},
        {prop: 'recommend_source_cn', label: '推荐方', width: 100},
        {prop: 'recommend_source_detail', label: '推荐方详情', minWidth: 160},
        {prop: 'task_intention_cn', label: '电话做单意向', width: 120},
        {prop: 'task_intention_remark', label: '做单意向备注', minWidth: 180},
        {prop: 'recommend_other_intention_cn', label: '推荐他人意向', width: 120},
        {prop: 'recommend_remark', label: '推荐意向备注', minWidth: 180},
        {prop: 'record_detail', label: '记录详情', minWidth: 200},
        {prop: 'communicator', label: '沟通人', width: 100},
        {prop: 'created_at', label: '沟通时间', width: 160},
        {prop: 'updated_at', label: '更新时间', width: 160},
      ],
      dialogTitle: '',
      dialogVisible: false,
      record_obj: {},
      lockUserId: false,
    }
  },
  computed: Vuex.mapState({
    options: state => state.users.userOptions,
    user: state => state.login.user,
  }),
  methods: {
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('searchCustomerService', params)
      // return request.page('getQueryCustomerService', params)
    },
    addNewUserServiceRecord () {
      this.record_obj = {userid: this.$route.query.userid}
      this.dialogTitle = '新增用户沟通记录'
      this.lockUserId = true
      this.dialogVisible = true
    },
    updateUserServiceRecord (record) {
      this.record_obj = record
      this.dialogTitle = '修改用户沟通记录'
      this.lockUserId = true
      this.dialogVisible = true
    },
    closeAndRefresh () {
      this.dialogTitle = ''
      this.dialogVisible = false
      this.record_obj = {}
      this.lockUserId = false
      this.onRefresh()
    },
  },
}
</script>
<style lang="scss"
       scoped></style>



// WEBPACK FOOTER //
// src/views/users/pages/detail/UsersService.vue